import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useRealtimeProjects } from '@/hooks/use-realtime';
import { Button } from '@/components/ui/button';
import { AppBrand, AppSidebar } from '@/components/layout/app-sidebar';

interface AppLayoutProps {
    children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useRealtimeProjects();

    return (
        <div className="flex h-screen">
            <div className="fixed top-0 left-0 right-0 z-40 flex h-14 items-center justify-between border-b border-white/10 backdrop-blur-md bg-white/5 px-4 md:hidden">
                <AppBrand />
                <Button variant="ghost" size="icon" onClick={() => setSidebarOpen((open) => !open)}>
                    {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </Button>
            </div>

            {sidebarOpen && (
                <button
                    className="fixed inset-0 z-40 bg-black/50 md:hidden"
                    onClick={() => setSidebarOpen(false)}
                    aria-label="Close navigation"
                />
            )}

            <AppSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <main className="flex-1 overflow-auto pt-14 md:pt-0">
                {children}
            </main>
        </div>
    );
}
